import {
  LIST_NEWS_PORTAL,
  RESET_NEWS_PORTAL,
} from 'volto-ministerio-publico-federal/constants';

interface ListNewsPortalState {
  error: unknown;
  hasError: boolean;
  result: { items?: any[]; items_total?: number; batching?: unknown };
  loaded: boolean;
  loading: boolean;
}

const initialState: ListNewsPortalState = {
  error: null,
  hasError: false,
  result: {},
  loaded: false,
  loading: false,
};

/**
 * Concatena a página nova ao que já está na tela, sem repetir item.
 *
 * A deduplicação por `@id` não é zelo: em modo estrito o React roda o efeito
 * duas vezes, e sem ela o "Mostrar mais" duplicaria o lote inteiro.
 */
const appendItems = (current: any[] = [], incoming: any[] = []) => {
  const seen = new Set(current.map((item) => item?.['@id']));

  return [...current, ...incoming.filter((item) => !seen.has(item?.['@id']))];
};

export const listNewsPortalReducer = (
  state = initialState,
  action: any = {},
) => {
  switch (action.type) {
    case `${LIST_NEWS_PORTAL}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case `${LIST_NEWS_PORTAL}_SUCCESS`:
      return {
        ...state,
        // `items_total` e `batching` vêm sempre do response mais novo; só a
        // lista de itens acumula.
        result: action.append
          ? {
              ...action.result,
              items: appendItems(state.result?.items, action.result?.items),
            }
          : action.result,
        loading: false,
        loaded: true,
      };
    case `${LIST_NEWS_PORTAL}_FAIL`:
      return {
        ...state,
        error: action.error,
        hasError: true,
        loading: false,
      };
    case RESET_NEWS_PORTAL:
      return initialState;
    default:
      return state;
  }
};

export default listNewsPortalReducer;
